import Entity from './entity'

export default abstract class AuditedEntity extends Entity {

  createdOn = new Date()
  createdBy: string | null = null
  changedOn: Date | null = null
  changedBy: string | null = null
}
